import { useEffect, useState } from "react";
import styled from "styled-components";
export default Image = ({src}) =>{
    return (
        <img src={src} />
    )
}

const StyledImage = styled.img`
`
export const ImageWithFallback = ({mainSrc, fallback, className}) => {
    const [src, setSrc] = useState();
    const [error, setError] = useState(false);
    const [showImg, setShowImg] = useState(false)
    useEffect(() => {
        setSrc(mainSrc || fallback)
        setShowImg(true)
    }, [ mainSrc, fallback])
    function handleImageError() {
        if (!error) {
            // console.log('img error...')
            // console.log(src, fallback)
            setSrc(fallback);
            setError(true);
        }
    }
    return showImg && <StyledImage src={src} onError={handleImageError} className={className} />
 
}